import React from 'react';
import './styles.scss';

const Footer = () => {
  return (
    <footer className="MainFooter">
        <div>
          Новостник <div className="smal"> Single Page Application</div>
        </div>
        <div className="smal">Новостной проект</div>
        <div>
          <div className="smal"> Made by</div>
           Галина Козак</div>
    </footer>
      
  );
}

export default Footer;